export const IconBarchart: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24134_23004)">
      <mask
        id="mask0_24134_23004"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_24134_23004)">
        <path
          d="M3 3V21"
          stroke="#F59E0B"
          strokeWidth="1.68"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 14.333H15V18C15 18.552 14.552 18.9999 14 18.9999H3V14.333Z"
          stroke="#F59E0B"
          strokeWidth="1.68"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 9.66699H20C20.552 9.66699 21 10.115 21 10.667V13.334C21 13.886 20.552 14.334 20 14.334H3V9.66699Z"
          stroke="#F59E0B"
          strokeWidth="1.68"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 5H17C17.552 5 18 5.448 18 6V9.66699H3V5Z"
          stroke="#F59E0B"
          strokeWidth="1.68"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_24134_23004">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
